import { Button, Dialog, DialogActions, DialogContent } from "@mui/material";
import { useContext, useRef, useState } from "react";
import { UsinasContext } from "../context/UsinasContextProvider";
import { DialogHeader } from "../../../auth/components/PasswordRecoveryModal";
import { ConfirmationModal } from "../../../main/components/ConfirmationModal";
import { usinasApi } from "../../../services/api";
// import { ErrorModal } from "../../../main/components/ErrorModal";
import { ActionAlert } from "../../../main/components/alerts/ActionAlert";
import { ReportOptions, Support } from "../types";
import { UsinaSupportEditForm } from "./UsinaSupportEditForm";
import { MainContext } from "../../../main/context/MainContextProvider";
import { GenerationType } from "../../operations/types";

export function SupportDataModal(props: {
  open: boolean;
  setOpen: (open: boolean) => void;
}) {
  const { usina, setUsina } = useContext(UsinasContext);
  const { userIsAdm, userIsClient } = useContext(MainContext);

  const { open, setOpen } = props;
  const [newSupport, setNewSupport] = useState<Support>();
  const [newReportOprions, setNewReportOprions] = useState<ReportOptions>();
  const [idSolicitante, setIdSolicitante] = useState<string>();
  const [generationType, setGenerationType] = useState<GenerationType>();
  const [plcGatewayDeviceId, setPlcGatewayDeviceId] = useState<string>();
  const [openEditConfirmationModal, setOpenEditConfirmationModal] =
    useState(false);
  const [openErrorModal, setOpenErrorModal] = useState(false);
  const [openSuccessModal, setOpenSuccessModal] = useState(false);
  const [canEdit, setCanEdit] = useState(false);
  const usinaId = usina && "usinaIds" in usina ? usina.usinaIds.id : "";
  const onClose = () => setOpen(false);

  const formRef = useRef<HTMLFormElement | null>(null);
  const handleFormSubmit = async () => {
    if (formRef.current) formRef.current.submitForm();
    setOpenEditConfirmationModal(true);
  };

  const [newClusterName, setNewClusterName] = useState("");
  const [cluster, setCluster] = useState<string>();
  return (
    <>
      <Dialog
        onClose={onClose}
        aria-labelledby="customized-dialog-title"
        open={open}
        sx={{
          "& .MuiDialog-paper": {
            maxWidth: { xs: "sm", md: "md" },
            width: "100%",
            height: "100vh",
          },
        }}
      >
        <DialogHeader id="customized-dialog-title" onClose={onClose}>
          Dados de Suporte da Usina
        </DialogHeader>
        <DialogContent dividers sx={{ height: "100vh" }}>
          <UsinaSupportEditForm
            open={open}
            setCanEdit={setCanEdit}
            setNewSupport={setNewSupport}
            setOpenConfirmSupportEditModal={setOpenEditConfirmationModal}
            setIdSolicitante={setIdSolicitante}
            setNewReportOprions={setNewReportOprions}
            newClusterName={newClusterName}
            setNewClusterName={setNewClusterName}
            setCluster={setCluster}
            setGenerationType={setGenerationType}
            setPlcGatewayDeviceId={setPlcGatewayDeviceId}
            ref={formRef}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={onClose}>Fechar</Button>
          {(userIsAdm || userIsClient) && (
            <Button
              disabled={!canEdit}
              variant="contained"
              color="primary"
              onClick={handleFormSubmit}
            >
              Atualizar dados de Suporte
            </Button>
          )}
        </DialogActions>
      </Dialog>

      <ConfirmationModal
        open={openEditConfirmationModal}
        setOpen={setOpenEditConfirmationModal}
        title="Atualizar dados de Suporte da Usina"
        contentText="Deseja confirmar a atualização dos dados de suporte da Usina?"
        onConfirm={async () => {
          if (usinaId) {
            await usinasApi.patchUsina(usinaId, {
              support: newSupport,
              idSolicitante: idSolicitante || undefined,
              reportOptions: newReportOprions,
              clusterId: cluster ?? undefined,
              newClusterName: cluster == "newCluster" ? newClusterName ?? undefined : undefined,
              generationType: generationType,
              plcGatewayDevice: plcGatewayDeviceId !== undefined
                ? { deviceId: plcGatewayDeviceId }
                : null,
            });
            const updatedUsina = await usinasApi.getUsina(usinaId);
            setUsina(updatedUsina);
          }
        }}
        setOpenErrorModal={setOpenErrorModal}
        setOpenSuccessModal={setOpenSuccessModal}
      />
      <ActionAlert
        message="Os dados de Suporte da Usina foram atualizados com sucesso!"
        severity="success"
        open={openSuccessModal}
        setOpen={setOpenSuccessModal}
        onClose={() => {
          setOpen(false);
        }}
      />
      <ActionAlert
        message="Ocorreu um erro ao editar os dados de suporte da usina! Tente novamente mais tarde."
        severity="error"
        open={openErrorModal}
        setOpen={setOpenErrorModal}
        onClose={() => {
          setOpen(false);
          setOpenEditConfirmationModal(false);
        }}
      />
      {/* <SuccessModal
        open={openSuccessModal}
        setOpen={setOpenSuccessModal}
        title="Dados de Suporte da Usina atualizada com Sucesso!"
        contentText="Os dados de Suporte da Usina foram atualizados com sucesso!"
        onClose={() => {
          setOpen(false);
        }}
      />
      <ErrorModal
        open={openErrorModal}
        setOpen={setOpenErrorModal}
        title="Erro ao editar os dados de Suporte da Usina!"
        contentText="Ocorreu um erro ao editar os dados de suporte da usina! Tente novamente mais tarde."
        onClose={() => {
          setOpen(false);
          setOpenEditConfirmationModal(false);
        }}
      /> */}
    </>
  );
}
